import { createAsyncActionType } from './index';

export const REMOTE_CLASSROOM_SURVEY_CONTENT_GET = createAsyncActionType('remoteclassroom', 'REMOTE_CLASSROOM_SURVEY_CONTENT_GET');

export const REMOTE_CLASSROOM_SET_INSERT_SURVEY = createAsyncActionType('remoteclassroom', 'REMOTE_CLASSROOM_SET_INSERT_SURVEY');
